module.exports = __webpack_public_path__ + "img/59.7f6d6a4f.jpg";